// extracted by mini-css-extract-plugin
export var attribution = "_br-4";
export var authorName = "_br-5";
export var quote = "_br-3";
export var testimonial = "_br-2";
export var trustedBy = "_br-0";
export var trustedByLabel = "_br-1";